import axios from 'axios';
import { ServiceModels } from './api.helpers.types';

const baseApiControllerUrl = '/api';

export const SendReminder = ({ params }: ServiceModels.SendReminderRequest) =>
    axios.post<ServiceModels.SendReminderResponse>(`${baseApiControllerUrl}/SendReminder`, null, { params });

export const SetLegalRepresentativeRole = ({ params }: ServiceModels.SetLegalRepresentativeRoleRequest) =>
    axios.post<ServiceModels.SetLegalRepresentativeRoleResponse>(`${baseApiControllerUrl}/SetLegalRepresentativeRole`, null, { params });

export const GetPromoData = (params: ServiceModels.GetPromoDataRequest) =>
    axios.get<ServiceModels.GetPromoDataResponse>(`${baseApiControllerUrl}/GetPromoData`, {
        params,
        transformResponse: [
            (data) => {
                let resp;
                try {
                    resp = JSON.parse(data);
                    if (resp.articles) resp.articles = JSON.parse(atob(resp.articles));
                    if (resp.campaign) resp.campaign = JSON.parse(atob(resp.campaign));
                } catch (error) {
                    throw Error(
                        `[requestClient] Error parsingJSON data - ${JSON.stringify(
                            error
                        )}`
                    );
                }
                return resp;
            },
        ],
    });

export const GetContract = (params: ServiceModels.GetContractRequest) =>
    axios.get<ServiceModels.GetContractResponse>(`${baseApiControllerUrl}/GetECContract`, { params });

export const SetPromoData = (data: ServiceModels.SetPromoDataRequest) =>
    axios.post<ServiceModels.SetPromoDataResponse>(`${baseApiControllerUrl}/SetPromoData`, data);
